import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2MovementIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 40.994 47.04",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 47.04),
    children: [/*#__PURE__*/jsx("circle", {
      cx: "21.972",
      cy: "6.241",
      r: "5.241"
    }), /*#__PURE__*/jsx("path", {
      d: "M37.534 10.043a2.983 2.983 0 00-3.524 2.35 4.942 4.942 0 01-5.68 3.917l-16.267-2.332a9.71 9.71 0 00-10.955 7.256 3 3 0 002.176 3.634 3.075 3.075 0 00.731.09 3 3 0 002.883-2.264 3.712 3.712 0 014.269-2.8l3.853.553-2.532 8.817a2.979 2.979 0 01-2.5 2.292l-6.417.916a3 3 0 10.849 5.93l6.417-.914a8.931 8.931 0 007.038-5.445l1.324.379a2.971 2.971 0 012.146 3.248l-.859 6.888a2.995 2.995 0 105.942.743l.861-6.884a8.939 8.939 0 00-6.433-9.76l-1.276-.363 1.438-4.98 6.425.92a10.935 10.935 0 0012.441-8.669 3 3 0 00-2.35-3.522z"
    })]
  });
};

export { PM2MovementIcon };
//# sourceMappingURL=movement.js.map
